<template>
    <div class="rates-container">
        <div class="filter-title">
            <typo name="body-14-light">Valeur du taux </typo>
        </div>
        <div class="search-rate-cond-container">
            <v-select
                v-model="condition"
                :items="conditionItems"
                item-text="label"
                item-value="value"
                append-icon="mdi-chevron-down"
                dense
                outlined
                hide-details
                class="rounded-0"
            />
        </div>
        <div class="search-rate-value-container">
            <v-text-field
                v-model="numberValue"
                hide-details
                single-line
                type="number"
                dense
                outlined
                class="rounded-0"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: ["value", "annotationOptions"],
    data() {
        return {
            numberValue: this.getNumberValue(),
            condition: this.getCondition(),
            conditionItems: [
                { label: "=", value: "$eq" },
                { label: ">", value: "$gt" },
                { label: "<", value: "$lt" },
            ],
        };
    },
    methods: {
        getNumberValue() {
            if (this.value) {
                return this.value.numberValue;
            } else {
                return null;
            }
        },
        getCondition() {
            if (this.value && this.value.condition) {
                return this.value.condition;
            } else {
                return "$eq";
            }
        },
    },
    watch: {
        async numberValue(value) {
            this.$emit("input", {
                numberValue: value,
                condition: this.condition,
            });
        },
        async condition(value) {
            this.$emit("input", {
                numberValue: this.numberValue,
                condition: value,
            });
        },
        value(_value) {
            this.numberValue = _value ? _value.numberValue : null;
            this.condition = _value ? _value.condition : "$eq";
        },
    },
};
</script>

<style lang="sass" scoped>
.rates-container
    display: flex
    align-items: center

.filter-title
    margin-right: 10px

.search-rate-cond-container
    width: 72px
    margin: 0 16px
    &.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot
        border-radius: 0
        &.v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections
            padding: 8px 0

.search-rate-value-container
    width: 140px
    margin: 0 8px
</style>
